const AdminReducer = (state, action) => {
  switch (action.type) {
    // Category
    case "CATEGORY_MODAL":
      if (action.data) {
        return {
          ...state,
          category: {
            ...state.category,
            modal: action.data,
          },
        };
      } else {
        return {
          ...state,
          category: {
            ...state.category,
            modal: action.data,
            id: 0,
            category_name: "",
            category_short: "",
          },
        };
      }
    case "CATEGORY_REFRESH":
      return {
        ...state,
        category: {
          ...state.category,
          refresh: state.category.refresh + 1,
          id: 0,
          category_name: "",
          category_short: "",
        },
      };
    case "CATEGORY_NAME":
      return {
        ...state,
        category: {
          ...state.category,
          category_name: action.data,
        },
      };
    case "CATEGORY_LIST":
      return {
        ...state,
        category: {
          ...state.category,
          list: action.data,
        },
      };
    case "CATEGORY_EDIT_FORM":
      return {
        ...state,
        category: {
          ...state.category,
          id: action.id,
          category_name: action.category_name,
          category_short: action.category_short,
          modal: true,
        },
      };
    case "CATEGORY_CHANGE":
      return {
        ...state,
        category: {
          ...state.category,
          ...action.data,
        },
      };
    // Category
    // Article
    case "ARTICLE_MODAL":
      if (action.data) {
        return {
          ...state,
          article: {
            ...state.article,
            modal: action.data,
          },
        };
      } else {
        return {
          ...state,
          article: {
            ...state.article,
            modal: action.data,
            id: 0,
            category_id: 0,
            article_name: "",
            users: [],
            departments: [],
            refresh: 0,
          },
        };
      }
    case "ARTICLE_FORM_CHANGE":
      return {
        ...state,
        article: {
          ...state.article,
          ...action.data,
        },
      };
    case "ARTICLE_USERS":
      return {
        ...state,
        article: {
          ...state.article,
          users: action.data,
        },
      };
    case "ARTICLE_DEPARTMENT_LIST":
      return {
        ...state,
        article: {
          ...state.article,
          department_list: action.data,
        },
      };
    case "ARTICLE_DEPARTMENT":
      return {
        ...state,
        article: {
          ...state.article,
          departments: action.data,
        },
      };
    case "ARTICLE_REFRESH":
      return {
        ...state,
        article: {
          ...state.article,
          refresh: state.article.refresh + 1,
          id: 0,
          category_id: 0,
          article_name: "",
          users: [],
          departments: [],
        },
      };
    case "ARTICLE_NAME":
      return {
        ...state,
        article: {
          ...state.article,
          category_name: action.data,
        },
      };
    case "ARTICLE_LIST":
      return {
        ...state,
        article: {
          ...state.article,
          list: action.data,
        },
      };
    case "ARTICLE_EDIT_FORM":
      return {
        ...state,
        article: {
          ...state.article,
          id: action.id,
          category_name: action.category_name,
          modal: true,
        },
      };
    // Article
    // Data
    case "DATA_CHANGE_STATE":
      return {
        ...state,
        data: {
          ...state.data,
          ...action.data,
        },
      };
    // Data
    default:
      return state;
  }
};
export default AdminReducer;
